'use client';

import { Badge } from '../badge';
import { Button } from '../button';

// gloss
export type SaveViewControlsProps = {
  isDirty: boolean;
  isOwner: boolean;
  onSave: () => void;
  onSaveAsNew: () => void;
};

// gloss
const SaveViewControls = ({ isDirty, isOwner, onSave, onSaveAsNew }: SaveViewControlsProps) => {
  if (!isDirty) return null;

  return (
    <>
      <Badge variant="warning">Unsaved changes</Badge>
      {isOwner ? (
        <Button variant="outline" size="sm" onClick={onSave}>
          Save
        </Button>
      ) : (
        <Button variant="outline" size="sm" onClick={onSaveAsNew}>
          Save as new view
        </Button>
      )}
    </>
  );
};

export { SaveViewControls };
